import SignUpLayout from "../../components/signup/layout";
import Payment from "../payment";
import { useLocation } from "react-router-dom";

export default function SignUpPayment() {
  const location = useLocation();
  return (
    <SignUpLayout
      step={location.pathname === "/signup/payment" ? 5 : 6}
      type={location.pathname === "/signup/ngn" ? 2 : 0}
      steps={location.pathname === "/signup/payment" ? [3, 4, 5] : [4, 5, 6]}
    >
      <Payment />
    </SignUpLayout>
  );
}
